module.exports = __webpack_public_path__ + "img/f3.88aea311.png";